module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABABAMAAABYR2ztAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAJcEhZcwAAAEgAAABIAEbJaz4AAAAbUExURUxpcYqKioqKioqKioqKioqKioqKioqKioqKiqGGdncAAAAIdFJOUwCqNBXf8slphfY4QgAAAG9JREFUeNrtzCEOgDAQRNFJewIUtgJ8BeEAYKpReAyWOwDZY5MlIVRsF4HdZ2fyYYz5Y6sytXDoKbMIB7+++xmhJ0ZIfHr2PULU6QFOqAFOaAHm0h0IKGr4MKDMzURHgKIlmgA1wQE1MUHnAowxXy4clDEWi7/73wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/imgs/kfc/down.png
// module id = RG1B
// module chunks = 1